export { default } from './pwa-installer'
